module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-4@3x.jpg?87821e51";